import React, { useState } from "react";
import { FamilyForm } from "./FamilyForm";

export const FamilyRegistration = ({ setShowModal }) => {
  return <FamilyForm setShowModal={setShowModal} isEdit={false} />;
};